<template>
  <div
    :class="{ 'hmd-page': true, 'has-header': hasHeaderSlot, 'has-footer': hasFooterSlot }"
    :style="{ 'padding-bottom': hasFooterSlot ? paddingBottom + 'px' : '0px' }"
    class="ub ub-ver ub-f1"
  >
    <div v-if="hasHeaderSlot" class="hmd-page__hd">
      <slot name="header"></slot>
    </div>

    <div v-if="hasBodySlot" class="hmd-page_bd">
      <slot name="body"></slot>
    </div>
    <div v-else class="hmd-page__bd">
      <slot></slot>
    </div>

    <div v-if="hasFooterSlot" class="hmd-page__ft">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, Comment } from "vue";
import { useRoute } from "vue-router";
export default defineComponent({
  isGlobal: true,
  name: "HmdPage",
  props: {},
  computed: {
    hasHeaderSlot() {
      return this.$slots.header && this.$slots.header().findIndex((o) => o.type !== Comment) !== -1;
    },

    hasBodySlot() {
      return this.$slots.body && this.$slots.body().findIndex((o) => o.type !== Comment) !== -1;
    },

    hasFooterSlot() {
      return this.$slots.footer && this.$slots.footer().findIndex((o) => o.type !== Comment) !== -1;
    },
  },
  setup(props, { emit }) {
    let route = useRoute();
    let paddingBottom = 44;
    if (route.path.indexOf("/detail/") >= 0) {
      paddingBottom = 16;
    }
    return {
      paddingBottom,
    };
  },
});
</script>

<style lang="less">
@import "./index";
</style>
